import React from 'react';

import '../css/whitelabels.css';
import { Reply } from '@material-ui/icons';
import { Check, DoubleArrow } from '@material-ui/icons';

import { TOUR_IMAGES_URL } from '../constants/apiUrls/apiUrls';
import callApi from '../utils/callApi';
import playOverlay from '../assets/play_overlay.png';
import nudeNewsLogo from '../assets/nudenews-logo.png';


class TourPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { images: [] };
  }

  componentDidMount() {
    const navigation = document.getElementById('navigation');
    if (navigation) {
      navigation.style.display = 'none';
    }
    callApi(TOUR_IMAGES_URL, 'GET', { size: 12 }).then((res) => {
      if (res.status === 200) {
        this.setState({ images: res.data });
      }
    });
  }

  render() {
    return (<div id="default-tour">
      <nav>
        <div className="container">
          <ul id="tour-navbar">
            <li id="tour-navbar-logo">
              <a href="http://join.nudenews.com/track/MTAzMzY4MS4xMDAxMS4xMDU2LjM2ODEuMS4wLjAuMC4w/join">
                <div className="vertical-helper" />
                <img alt="Logo" className="logo-responsive" src={nudeNewsLogo} />
              </a>
            </li>
            <li id="left-info">
              <div>
                <Check />
                                    &nbsp;6 HD shows per week
              </div>
            </li>
            <li id="right-info">
              <div>
                <Check />
                                    &nbsp;World's Most Gorgeous News Team
              </div>
              <div>
                <Check />
                                    &nbsp;Huge On-Demand Archive
              </div>
            </li>
            <li id="get-access">
              <div id="sign-up-header">
                <a className="btn btn-large instant-access" href="http://join.nudenews.com/track/MTAzMzY4MS4xMDAxMS4xMDU2LjM2ODEuMS4wLjAuMC4w/join">
                  Get Instant Access&nbsp;
                  <DoubleArrow fontSize="inherit" />
                </a>
                <div className="member-login">
                  <a className="member-login" href="/account/login">
                    Member Login&nbsp;
                    <DoubleArrow fontSize="inherit" />
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div className="content">
        <div className="container">
          <section className="tour-pics clearfix">
            <div className="gif-tour-content">
              <section className="tour-pics">
                {this.state.images.map((img) => (
                  <div
                    key={img.image}
                    className="default-tour-card"
                  >
                    <div className="tour-card-inner">
                      <a href="http://join.nudenews.com/track/MTAzMzY4MS4xMDAxMS4xMDU2LjM2ODEuMS4wLjAuMC4w/join">
                        <img
                          alt="Clear"
                          className="img-responsive tour-pics-delayed gif-tour-increment-view-count"
                          src={img.image}
                          style={{ opacity: 1 }}
                        />
                        <img
                          alt="Play overlay"
                          className="img-responsive tour-pic-overlay"
                          src={
                            playOverlay
                          }
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </section>
            </div>
          </section>
          <section className="full-access-btn clearfix">
            <div className="container">
              <div className="icon">
                <Reply fontSize="inherit" />
              </div>
              <a className="btn instant-access" href="http://join.nudenews.com/track/MTAzMzY4MS4xMDAxMS4xMDU2LjM2ODEuMS4wLjAuMC4w/join">
                Click Here to Get Full Access to www.nudenews.com
              </a>
              <div className="icon icon--right">
                <Reply fontSize="inherit" />
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="content light" id="tour-footer">
        <div className="container">
          <ul className="list-inline" />
        </div>
      </div>
    </div>);
  }
}

export default TourPage;
